import { configureStore } from '@reduxjs/toolkit';
import { UserProfile, App } from './reducers';

export default configureStore({
	reducer: {
		UserProfile,
		App,
	},
});
